import { TAppState } from '../../types/appState';

export function chatListSelector(state: TAppState) {
  return state.chatList;
}
